import styled, { css } from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Wrapper = styled.div<{ $sliderDataRole?: string; $slidesCount?: number }>`
  position: relative;
  width: 100%;

  /* Hide the slider when there are no slides */
  ${({ $slidesCount }) =>
    !$slidesCount &&
    css`
      display: none;
      margin-top: 0;
    `}/*
   * This conditional styling checks if $sliderDataRole prop exists and then:
   * 1. Looks for any child elements with the data-role attribute matching $sliderDataRole value
   * 2. If no such children exist (using the :not and :has selectors), hides the entire wrapper
   * 3. This effectively makes the carousel invisible when it doesn't contain relevant slider items
   */
`

export const NavigationButton = styled.button<{
  $direction: 'left' | 'right'
  $isVisible: boolean
}>`
  display: none;

  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${({ $direction }) => ($direction === 'left' ? 'left: -2px;' : 'right: -2px;')}
  z-index: 1;
  background: var(--bg-primary);
  border-radius: var(--radius-brand);
  width: 40px;
  height: 40px;

  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
  transition:
    opacity 0.2s ease,
    visibility 0.2s ease;

  svg path {
    fill: var(--icon-primary);
  }

  &:hover {
    opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
    background: var(--bg-primary-hover);
  }

  ${mediaQueries.tablet} {
    display: flex;
  }
`

export const Slider = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  gap: var(--space-400);

  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }

  /* For smooth scrolling on mobile */
  @media (hover: none) {
    scroll-behavior: smooth;
  }
`

export const Item = styled.div`
  position: relative;
  padding: var(--space-200) var(--space-300);

  align-items: center;
  justify-content: space-between;

  display: flex;
  gap: var(--space-200);
  cursor: pointer;

  border-radius: var(--radius-brand);

  /* Make items snap when scrolling */
  scroll-snap-align: start;

  //flex: 0 0 auto;
  flex: 1;

  /* Smooth transition for hover effect */
  transition: background 0.2s ease;
  /* Prevent text from wrapping */
  white-space: nowrap;
`

export const ContentLeft = styled.div`
  display: flex;
  gap: var(--space-300);
`

export const ItemEmote = styled.div`
  color: var(--text-primary);
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-300); /* 142.857% */
  letter-spacing: var(--font-letter-spacing-loose);
`

export const ItemText = styled.div`
  color: var(--text-primary);
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-300); /* 142.857% */
  letter-spacing: var(--font-letter-spacing-loose);
`

export const GradientOverlay = styled.div<{ $side: 'left' | 'right'; $isVisible: boolean }>`
  width: 92px; /* 80px + 12px white space */
  height: 40px;
  flex-shrink: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
  transition:
    opacity 0.2s ease,
    visibility 0.2s ease;

  ${({ $side }) =>
    $side === 'left'
      ? css`
          background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, var(--bg-primary) 100%);
          right: 36px;
          /* Create space between button and gradient start */
          background-position: 12px 0;
          background-size: 80px 100%;
          background-repeat: no-repeat;
        `
      : css`
          background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, var(--bg-primary) 100%);
          left: 36px;
          /* Create space between button and gradient start */
          background-position: 0 0;
          background-size: 80px 100%;
          background-repeat: no-repeat;
        `}

  display: none;

  ${mediaQueries.tablet} {
    display: block;
  }
`
